import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Card } from 'primeng/card';
import { AdminPanelUserDetails } from '../../../../../../../../shared/models/admin-panel-user-details';
import { AdminPanelUserOrganizationRelatedPersonsTableComponent } from '../admin-panel-user-organization-related-persons-table/admin-panel-user-organization-related-persons-table.component';

@Component({
  selector: 'app-admin-panel-user-organization-related-persons-section',
  imports: [Card, AdminPanelUserOrganizationRelatedPersonsTableComponent],
  templateUrl:
    './admin-panel-user-organization-related-persons-section.component.html',
  styleUrl:
    './admin-panel-user-organization-related-persons-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelUserOrganizationRelatedPersonsSectionComponent {
  userDetails = input.required<AdminPanelUserDetails>();
  organizationId = input.required<number>();
}
